import { BONUS_TYPE } from "constants/bonus.constants";

const getBonusAmountInfo = ({ bonus, currencyCode }) => {
	switch (bonus.bonusType) {
		case BONUS_TYPE.FREEBET:
			return `${bonus.roundCount}x ${bonus.amount} ${currencyCode}`;
		case BONUS_TYPE.FREEAMOUNT:
			return `${bonus.amount} ${currencyCode}`;
		default:
			break;
	}

	return null;
};

export default getBonusAmountInfo;
